import Component from "../abstracts/Component";
import DatePickerComponent from "./DatePickerComponent";
import { Select2Init } from "../utils/Select2Init";

export default class ContactUsComponent extends Component {
  get SELECTORS() {
    return {
      contactUsForm: '#contactUsForm',
      formContainer: '#formContainer',
      contactResponse: '#contactResponse',
      contactUsFormWrapper: '#contactus-form-wrapper',
      subject: '#subject',
      contactFormTrigger: '#contact-form-trigger',
      returns: '[data-js-returns]',
      orders: '[data-js-orders]',
      subjectCode: '#subjectCode',
      tab: '[data-tab]',
      trigger: '[data-trigger]',
      chatBtn: '[data-js-chat-link]',
      chatLabel: '[data-js-chat-label]',
      privacyCheckbox: '[data-js-privacy]',
      submitBtn: '[data-js-submit]',
      successSection: '[data-js-success]',
    }
  }

  constructor(htmlEl) {
    super(htmlEl);
    // CHAT BOX
    this.chatBtn = this.$component.querySelector(this.SELECTORS.chatBtn);
    this.chatLabel = this.$component.querySelector(this.SELECTORS.chatLabel);
    // CONTACT FORM
    this.tab = this.$component.querySelector(this.SELECTORS.tab);
    this.trigger = this.$component.querySelector(this.SELECTORS.trigger);
    this.readDOM();
  }

  readDOM() {
    this.contactUsForm = this.$component.querySelector(this.SELECTORS.contactUsForm);
    this.formContainer = this.$component.querySelector(this.SELECTORS.formContainer);
    this.contactUsFormWrapper = this.$component.querySelector(this.SELECTORS.contactUsFormWrapper);
    this.submitBtn = this.$component.querySelector(this.SELECTORS.submitBtn);
    this.privacyCheckbox = this.$component.querySelector(this.SELECTORS.privacyCheckbox);
    this.successSection = this.$component.querySelector(this.SELECTORS.successSection);
    this.contactFormTrigger = this.$component.querySelector(this.SELECTORS.contactFormTrigger);
    // SELECT MOTIVATION FIELDS
    this.subject = this.$component.querySelector(this.SELECTORS.subject);
    this.subjectCode = this.$component.querySelector(this.SELECTORS.subjectCode);
    this.returns = this.$component.querySelector(this.SELECTORS.returns);
    this.orders = this.$component.querySelector(this.SELECTORS.orders);
  }


  bindSubject() {
    $(this.subject).on("select2:select",(event) => {
      const selectedOptionIndex = event.currentTarget.selectedOptions[0].dataset.subjectId;
      this.subjectCode.value = selectedOptionIndex;
      this.showAdditionalData(Number(selectedOptionIndex));
    })
  }

  showAdditionalData(index) {
    switch (index) {
      case 8:
        if(this.orders) {
          this.orders.classList.add("hidden");
          this.handleFields(this.orders);
        }
        if(this.returns) {
          this.returns.classList.remove("hidden");
          this.handleFields(this.returns, false);
        }
        break;
      case 2:
        if(this.orders) {
          this.orders.classList.remove("hidden");
          this.handleFields(this.orders, false);
        }
        if(this.returns) {
          this.returns.classList.add("hidden");
          this.handleFields(this.returns);
        }
        break;
      default:
        if(this.orders) {
          this.orders.classList.add("hidden");
          this.handleFields(this.orders);
        }
        if(this.returns) {
          this.returns.classList.add("hidden");
          this.handleFields(this.returns);
        }
    }
  }

  handleFields(section, disabled = true) {
    const inputs = section.querySelectorAll('input');
    const selects = section.querySelectorAll('select');
    inputs ? inputs.forEach(input => input.disabled = disabled) : '';
    selects ? selects.forEach(select => select.disabled = disabled) : '';
  }

  handleSubmit() {
    this.contactUsForm.addEventListener("submit", event => {
      event.preventDefault();
      var disabled = $('#contactUsForm').find('select:disabled').removeAttr('disabled');
      if (window.RecapchaComponent && !window.RecapchaComponent.getResponseFromWidget('contactUsPage')) {
        // User have not completed the challenge
        return;
      }
      const formData = new FormData(event.target);
      this.submitBtn.disabled = true;
      disabled.attr('disabled','disabled');
      this.submitBtn.classList.add("--loading");
      fetch(window.location.href,
        {
          method: 'POST',
          body: formData
        }
      ).then(response => {
        this.submitBtn.classList.remove("--loading");
        if(response.ok) {
          this.contactFormTrigger.innerHTML = this.contactFormTrigger.dataset.submitMsg;
        }
        response.text().then(res => {
          const responseHtml = new DOMParser().parseFromString(res, 'text/html');
          if(responseHtml.querySelector(this.SELECTORS.contactResponse)) {
            this.formContainer.innerHTML = responseHtml.querySelector(this.SELECTORS.contactResponse).innerHTML;
            const contactForm = this.$component.querySelector(this.SELECTORS.contactUsForm);
            contactForm.classList.add('hidden');
            //attach all events to new HTML
            this.bindEvents();
          }
          this.contactUsFormWrapper.scrollIntoView({ block: "center", inline: 'center', behavior: "smooth" });
        })
      })
      .catch(error => console.error(error));
    });
  }

  //handle live chat enabled
  handleLiveChat() {
    if(this.chatBtn && this.chatLabel) {
      //enabled
      document.addEventListener('chatButtonEnabled', () => {
        this.chatBtn.removeAttribute('disabled');
        this.chatLabel.classList.remove("--not-available");
      });
      //disabled
      document.addEventListener('chatButtonDisabled', () => {
        this.chatBtn.setAttribute('disabled','');
        this.chatLabel.classList.add("--not-available");
      });
    }
  }

  handleCollapse(){
    if (this.trigger == null) return false;
    this.trigger.addEventListener("click",() => {
      // success section is hidden
      if(this.successSection.classList.contains("hidden")) {
        this.tab.classList.contains("hidden") ? this.tab.classList.remove("hidden") : this.tab.classList.add("hidden");
      } else {
        //success section visible
        this.successSection.classList.add("hidden");
        // If is custom Contact Us
        if (this.$component.classList.contains('contactus-custom')) {
          this.contactFormTrigger.classList.add('--invisible');
          this.contactFormTrigger.innerHTML = "";
        } else {
          this.contactFormTrigger.innerHTML = this.contactFormTrigger.dataset.mainMsg;
        }
      }
      this.contactUsForm.reset();
      this.resetForm(this.contactUsForm);
      this.contactUsForm.classList.remove("hidden");
      if(this.orders) {
        this.orders.classList.add("hidden");
        this.handleFields(this.orders);
      }
      if(this.returns) {
        this.returns.classList.add("hidden");
        this.handleFields(this.returns);
      }
    });
  }

  handlePrivacy() {
    this.privacyCheckbox.addEventListener("click", event => {
      this.submitBtn.disabled = !this.privacyCheckbox.checked;
    });
  }

  resetForm(form) {
    // if is custom Contact Us
    if (this.$component.classList.contains('contactus-custom')) {
      form.querySelectorAll('select').forEach(input => input.value = input.value);
      form.querySelectorAll('input').forEach(input => {
        if (input.type !== 'hidden') {
          input.value = '';
        }
      });
    } else {
      form.querySelectorAll('select').forEach(input => input.value = '');
      form.querySelectorAll('input').forEach(input =>  input.value = '');
    }
    form.querySelectorAll('textArea').forEach(input => input.value = '');

    form.querySelectorAll('.error').forEach(error => error.classList.remove('error'));

    form.querySelectorAll('.--msg-error').forEach(msg => msg.remove());

    form.querySelector(this.SELECTORS.submitBtn).disabled = true;
  }

  bindEvents() {
    this.readDOM();
    this.handleSubmit();
    const date = this.contactUsForm.querySelector("[data-js-component='DatePickerComponent']");
    const component = new DatePickerComponent(date);
    component.render();
    if (this.orders || this.returns) {
      this.bindSubject();
    }
    this.handlePrivacy();
    Select2Init();
  }

  render() {
    this.log('rendering...');
    this.handleLiveChat();
    this.handleCollapse();
    this.bindEvents();
  }
}
